import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/api.service';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { FieldValue, ServiceName } from '../../../../shared/constants/services.enum';
import { UnlinkAccessRequest } from '../../../../shared/models/unlink-user-request.model';
import { Utils } from '../../../../Utils/utils';
import { Observable } from 'rxjs';
import { DcMethodValues } from '../../../../shared/constants/dc-method.constants';

@Injectable({
  providedIn: 'root',
})
export class AccountManagementSharedService {
  constructor(private api: ApiService) { }

  private buildUnlinkAccessRequest(
    memberNumber: string,
    loginUerName: string,
    targetLogin: string,
    lang: string
  ): UnlinkAccessRequest {
    const request = new UnlinkAccessRequest();

    request.body.DCLoginName = loginUerName;
    request.body.DCLanguage = lang === 'ar' ? 'ARA' : 'ENU';
    request.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

    const srData =
      request.body.DCIncomingHierarchy['ListOfDC Community Portal SR Upsert IO'][
      'DC Community Portal SR'
      ];

    srData['SR Type'] = ServiceName.USER_MANAGEMENT;
    srData['Sub Type'] = ServiceName.UNLINK_ACCESS;
    srData['DC Channel'] =
      lang === 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN;
    srData.CSN = memberNumber;
    srData['DC Delink User ID'] = targetLogin;

    return request;
  }

  // This method is for unlink/remove user and myself
  unlinkUser(
    memberNumber: string,
    loginUerName: string,
    targetLogin: string,
    lang: string
  ) {
    const request = this.buildUnlinkAccessRequest(
      memberNumber,
      loginUerName,
      targetLogin,
      lang
    );

    return this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_MANAGE_SERVICE_REQUEST,
      request
    );
  }

  // This method is used to fetch user access details (used by user detail & update forms)
  getUserAccessDetails(
    csn: string,
    userId: string,
    dcMethod: string = DcMethodValues.GENERAL,
    lang: string = 'en'
  ): Observable<any> {
    const requestPayload = {
      body: {
        ProcessName: "DC Get Member User Access Details WF",
        'DC Channel': lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        'DC Method': dcMethod,
        CSN: csn,
        'Login Name': userId,
      },
    };

    return this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.RUN_PROCESS,
      requestPayload
    );
  }
}
